import { render, staticRenderFns } from "./RolesFilter.vue?vue&type=template&id=853d7334&scoped=true"
import script from "./RolesFilter.vue?vue&type=script&lang=js"
export * from "./RolesFilter.vue?vue&type=script&lang=js"
import style0 from "./RolesFilter.vue?vue&type=style&index=0&id=853d7334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853d7334",
  null
  
)

export default component.exports